import { useEffect } from 'react';
import './about.scss';
import { applySeo, siteUrl } from '../../utils/seo';

const About = () => {
    useEffect(() => {
        applySeo({
            title: 'About David Joyce | AstroDavido Astrophotography',
            description: 'Learn more about David Joyce and AstroDavido, his astrophotography portfolio focused on deep-sky, narrowband nebula, and planetary astrophotography.',
            canonicalPath: '/about/',
            ogImage: `${siteUrl}/logo192.png`,
            structuredData: {
                '@context': 'https://schema.org',
                '@type': 'ProfilePage',
                mainEntity: {
                    '@type': 'Person',
                    name: 'David Joyce',
                    alternateName: ['AstroDavido', 'astro_davido'],
                    description: 'Astrophotographer and web developer based in Lexington, Kentucky.',
                    sameAs: [
                        'https://www.instagram.com/astro_davido/',
                        'https://www.tiktok.com/@astro_davido',
                        'https://www.youtube.com/@astro_davido'
                    ],
                    homeLocation: {
                        '@type': 'Place',
                        name: 'Lexington, Kentucky'
                    },
                    url: `${siteUrl}/about/`
                }
            }
        });
    }, []);

    return (
        <div className='about-page'>
            <div className='about-card'>
                <div className='about-copy'>
                    <h1>About Me</h1>

                    <p>
                        I&apos;m David, an astrophotographer and web developer based in Lexington, Kentucky. I share my
                        work here as AstroDavido, also known as astro_davido and pronounced &ldquo;astro dah-vee-doh.&rdquo; I&apos;ve been fascinated by space for
                        most of my life, and Carl Sagan was a major early inspiration. The night sky has always felt
                        both humbling and endlessly interesting to me, and astrophotography became a natural way to
                        explore more of it with my own equipment.
                    </p>

                    <p>
                        Over the years I&apos;ve owned different telescopes and always wanted to see deeper than what was
                        immediately visible through the eyepiece. Because I image under heavily light-polluted skies,
                        astrophotography opened up a new way to experience the universe. I especially enjoy narrowband
                        nebula imaging, where 3nm filters help cut through the glow and reveal detail that would
                        otherwise be lost.
                    </p>

                    <p>
                        What keeps me coming back is not just the final image, but the entire process: planning a
                        target, setting up under the stars, deciding how to frame the shot, collecting data, and then
                        bringing it all together in processing. It&apos;s a creative challenge, a technical one, and a
                        personal one all at once.
                    </p>

                    <p>
                        Outside of astrophotography, I also enjoy chess and running. This site is a place to share the
                        images, projects, and occasional writing that have grown out of that lifelong fascination with
                        the night sky.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default About;
